import { render, staticRenderFns } from "./CommitExchange.vue?vue&type=template&id=1c88a084"
import script from "./CommitExchange.vue?vue&type=script&lang=js"
export * from "./CommitExchange.vue?vue&type=script&lang=js"
import style0 from "./CommitExchange.vue?vue&type=style&index=0&id=1c88a084&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports